import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyAshWMTrrxhOfkdYw6jurk09kQPuWyqxMo",
  authDomain: "deedmed-lives.firebaseapp.com",
  databaseURL: "https://deedmed-lives-default-rtdb.firebaseio.com",
  projectId: "deedmed-lives",
  storageBucket: "deedmed-lives.appspot.com",
  messagingSenderId: "125946472518",
  appId: "1:125946472518:web:30c0528e3eb96c96ecc247",
  measurementId: "G-QY7S8RF9TY",
};

const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });

export const getTokenFrom = async (
  setTokenFound,
  serviceWorkerRegistration
) => {
  try {
    // serviceWorkerRegistration is already resolved, no need to call .then()
    const currentToken = await getToken(messaging, {
      vapidKey:
        "BDe6F72v1JQcxpTb_UGS5WWQwGQEzcyTRR02JVTw7-AgktIUts_LiDXBbKLtwL9YDOSmDJlUwaeweN40RAiT_AY",
      serviceWorkerRegistration: serviceWorkerRegistration,
    });

    if (currentToken) {
      setTokenFound(currentToken);
      // console.log("FCM Token:", currentToken);
      // Track the token -> client mapping, by sending to backend server
      // show on the UI that permission is secured
    } else {
      // console.log(
      //   "No registration token available. Request permission to generate one."
      // );
      setTokenFound(false);
    }
  } catch (err) {
    // console.log("An error occurred while retrieving token: ", err);
    setTokenFound(false);
  }
};

// Alternative approach - handle service worker registration within this file
export const initializeFirebaseMessaging = async (setTokenFound) => {
  try {
    if ("serviceWorker" in navigator) {
      const registration = await navigator.serviceWorker.register(
        "../firebase-messaging-sw.js",
        { scope: "/app/" }
      );

      // console.log("Service Worker registered:", registration);

      const currentToken = await getToken(messaging, {
        vapidKey:
          "BDe6F72v1JQcxpTb_UGS5WWQwGQEzcyTRR02JVTw7-AgktIUts_LiDXBbKLtwL9YDOSmDJlUwaeweN40RAiT_AY",
        serviceWorkerRegistration: registration,
      });

      if (currentToken) {
        setTokenFound(currentToken);
        // console.log("FCM Token:", currentToken);
      } else {
        // console.log(
        //   "No registration token available. Request permission to generate one."
        // );
        setTokenFound(false);
      }
    } else {
      // console.log("Service Worker not supported");
      setTokenFound(false);
    }
  } catch (err) {
    console.error("Error initializing Firebase messaging:", err);
    setTokenFound(false);
  }
};
